export const TOGGLE_MENU_STATE = 'TOGGLE_MENU_STATE';
export const toggleMenuState = (state, menuOpened) => {
	return {
		...state,
		menuOpened,
	};
};

export const TOGGLE_MENU_UPDATE = 'TOGGLE_MENU_UPDATE';
export const toggleMenuUpdate = (state, menuToggleProgress) => {
	return {
		...state,
		menuToggleProgress,
	};
};

export const OPEN_ACCORDION_ITEM = 'OPEN_ACCORDION_ITEM';
export const openAccordionItem = (state, menuSelectedAnchor) => {
	return {
		...state,
		menuSelectedAnchor,
	};
};

export const globalReducer = (state, action) => {
	switch (action.type) {
		case TOGGLE_MENU_STATE:
			return toggleMenuState(state, action.menuOpened);
		case TOGGLE_MENU_UPDATE:
			return toggleMenuUpdate(state, action.menuToggleProgress);
		case OPEN_ACCORDION_ITEM:
			return openAccordionItem(state, action.menuSelectedAnchor);
		default:
			return state;
	}
};

export default globalReducer;
